// This file is auto-generated by @hey-api/openapi-ts
export {};
